// Single decision point for the Solicitudes UI/UX rework: resolves the redesigned list
// view when the society has HAS_NEW_AP_VIEW, else the current one. Default is the OLD view
// (flag false when the permission is absent). Neither view reads the flag.
//
// This is used directly as the `component` of the `requests` route record (instead of a
// dispatcher component rendered via `<component :is>`) so that the resolved component IS
// the one Vue Router registers for the route. That matters because Vue Router only invokes
// in-component navigation guards (e.g. `beforeRouteLeave`) for the component registered in
// the route record — a component mounted via `<component :is>` inside a wrapper is
// invisible to the router and its guards never fire. Both `Requests.vue` and
// `RequestsLegacy.vue` rely on their own `beforeRouteLeave` to persist filters
// (tab/page/search), so the resolved component must be the one the router actually sees.
//
// ACCEPTED TRADEOFF: Vue Router caches the resolved component per route record after the
// first resolution, so toggling HAS_NEW_AP_VIEW for a society requires a page reload to
// switch which view renders — it will not swap reactively mid-session.
import { checkFeatureFlag, FEATURES } from "@/features";

export function resolveRequestsView() {
  return checkFeatureFlag(FEATURES.NEW_AP_VIEW)
    ? import("@/views/requests/Requests.vue")
    : import("@/views/requests/RequestsLegacy.vue");
}
